import GoogleAnalytics from 'react-ga'

import axios from '../../utils/axios'
import api from '../../utils/api2'

GoogleAnalytics.initialize('UA-99057972-3')

export function fbq (a, b, c) {
  let didConvertFB = window.sessionStorage.getItem('didConvertFB')
  if (!didConvertFB) window.sessionStorage.setItem('didConvertFB', true)
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // dev code
    console.log('dev, not sending FBQ', a, b, c, didConvertFB)
  } else {
    if (window.fbq) {
      window.fbq(a, b, c)
      if (!didConvertFB) window.fbq('trackCustom', 'UserDidSomethingInteractive')
    }
  }
}

export function taboola (name) {
  window._tfa.push({ notify: 'event', name: name })
}

export function ga (a, b, c, d, e) {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // dev code
    console.log('dev, not sending GA', a, b, c, d, e)
  } else {
    window.ga(a, b, c, d, e)
  }
}

export function gaPv (link) {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // dev code
    console.log('dev, not sending GA', link)
  } else {
    GoogleAnalytics.pageview(link)
  }
}

export function adwords (a) {
  window.gtag('event', 'conversion', { 'send_to': 'AW-836870496/' + a })
}

export function fireLinkedInPixel () {
  const url = `https://dc.ads.linkedin.com/collect/?pid=186074&conversionId=242938&fmt=gif`
  return axios.get(url)
    .then(response => response.data)
    .catch(function (error) {
      console.log(error)
    })
}

export function trackView (input) {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // dev code
    console.log('dev, not sending trackView', input)
  } else {
    const url = '/api/track-view'
    return api.post(url, input)
  }
}
